import { WiredDashboardTaskList } from '@euler/app/tv/components/dashboard/TaskList';
import {
  HistoryTaskListTabItems,
  TaskListToolbar,
} from '@euler/app/tv/components/dashboard/TaskListToolbar';
import { useTaskListWithSearch } from '@euler/app/tv/functions/useTaskListWithSearch';
import { useScreenContentPadding } from '@euler/app/tv/functions/utils';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { View } from 'react-native';

export const HistoryScreen = wrapNavigatorScreen(() => {
  const theme = usePresentationTheme();
  const { rpx } = useResponsiveContext();
  const [marginLeft] = useScreenContentPadding();
  const taskList = useTaskListWithSearch({
    tabItems: HistoryTaskListTabItems,
    initialTabType: 'finished',
  });

  return (
    <View
      css={`
        flex: 1;
        background-color: ${theme.page.bg};
      `}
    >
      <TaskListToolbar
        tabs={HistoryTaskListTabItems}
        activeTabType={taskList.activeTabType}
        activeListMode={taskList.preferredMode}
        onModeChanged={taskList.onPreferredModeChange}
        loading={taskList.isRefreshing}
        onTabChanged={taskList.onActiveTabTypeChange}
        css={`
          margin-top: ${rpx(75)}px;
          padding-left: ${marginLeft}px;
          padding-right: ${rpx(64)}px;
        `}
      />
      <WiredDashboardTaskList
        debugLabel="history"
        tasks={taskList.data}
        preferredMode={taskList.preferredMode}
        showStatus={false}
        showFinishedTime={true}
        isRefreshing={taskList.isRefreshing}
        isLoading={taskList.isLoading}
        hasMore={taskList.hasMore}
        error={taskList.error}
        emptyText={`暂无已经完工的相关车辆服务信息`}
        onRefresh={taskList.onRefresh}
        onFetchMore={taskList.onFetchMore}
      />
    </View>
  );
});
